export const stableHash = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 10) - hash) + char;
    hash = hash & hash;
  }
  return `${hash.toString()}-${Date.now()}`;
};
